export class CurrentUser {
  constructor(
    public firstname?: string,
    public lastname?: string,
    public role?: string,
    public username?: string,
    public changePw?: boolean,
    public returnUrl?: string,
    public acceptedAgreement?: boolean
  ) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/models/current-user.ts